import React from 'react';
import {motion} from 'framer-motion';
import {useNavigate} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiArrowRight,FiCheckCircle,FiShield,FiAward,FiStar}=FiIcons;

export default function Hero() {
  const navigate=useNavigate();

  const exploreCare=()=> {
    navigate('/weightquiz');
  };

  return (
    <section className="relative overflow-hidden bg-[#fafaf9] pb-20 pt-32 lg:pb-32 lg:pt-48">
      <div className="absolute left-1/4 top-0 h-[600px] w-[600px] animate-blob rounded-full bg-teal-900/5 opacity-70 mix-blend-multiply blur-[100px]" />
      <div className="animation-delay-2000 absolute right-1/4 top-0 h-[600px] w-[600px] animate-blob rounded-full bg-emerald-900/5 opacity-70 mix-blend-multiply blur-[100px]" />
      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center gap-16 lg:flex-row">
          <motion.div
            initial={{opacity: 0,y: 30}}
            animate={{opacity: 1,y: 0}}
            transition={{duration: 0.8,ease: 'easeOut'}}
            className="flex items-start text-left lg:w-1/2"
          >
            <div>
              <div className="mb-8 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-xs font-bold uppercase tracking-widest text-slate-700 shadow-sm">
                <SafeIcon icon={FiAward} className="h-4 w-4 text-teal-600" />
                Care that fits your life
              </div>
              <h1 className="mb-6 text-5xl font-extrabold leading-[1.1] tracking-tight text-slate-900 sm:text-6xl lg:text-7xl">
                Weight loss care,
                <br />
                <span className="text-gradient-premium">made for you.</span>
              </h1>
              <p className="mb-10 max-w-xl text-lg font-light leading-relaxed text-slate-600 sm:text-xl">
                Explore convenient,clinician-guided telehealth care designed to support your weight loss goals from home.
              </p>
              <div className="mb-10 flex w-full flex-col gap-4 sm:w-auto sm:flex-row">
                <button
                  onClick={exploreCare}
                  className="group flex items-center justify-center gap-3 rounded-full bg-slate-900 px-8 py-4 text-lg font-bold text-white shadow-xl transition-all duration-300 hover:bg-teal-700 hover:shadow-teal-900/20"
                >
                  Explore Weight Loss Care
                  <SafeIcon icon={FiArrowRight} className="transition-transform group-hover:translate-x-1" />
                </button>
                <button
                  onClick={exploreCare}
                  className="rounded-full border border-slate-200 bg-white px-8 py-4 text-lg font-bold text-slate-900 shadow-sm transition-all duration-300 hover:border-slate-300 hover:bg-slate-50"
                >
                  Find Your Care
                </button>
              </div>
              <div className="grid w-full max-w-md grid-cols-2 gap-4 text-sm font-medium text-slate-600">
                <div className="flex items-center gap-2">
                  <SafeIcon icon={FiCheckCircle} className="text-teal-600" />
                  Licensed Providers
                </div>
                <div className="flex items-center gap-2">
                  <SafeIcon icon={FiCheckCircle} className="text-teal-600" />
                  Private Online Care
                </div>
                <div className="flex items-center gap-2">
                  <SafeIcon icon={FiShield} className="text-teal-600" />
                  Secure &amp;Convenient
                </div>
                <div className="flex items-center gap-2">
                  <SafeIcon icon={FiCheckCircle} className="text-teal-600" />
                  Care From Home
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{opacity: 0,scale: 0.95}}
            animate={{opacity: 1,scale: 1}}
            transition={{duration: 0.8,delay: 0.2,ease: 'easeOut'}}
            className="relative lg:w-1/2"
          >
            <div className="relative z-10 grid grid-cols-2 gap-4 sm:gap-6">
              <div className="mt-12 space-y-4 sm:space-y-6">
                <div className="premium-shadow relative overflow-hidden rounded-[2rem]">
                  <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Doctor consultation" className="h-48 w-full object-cover sm:h-64" />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent" />
                  <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2 text-sm font-medium text-white">
                    <SafeIcon icon={FiShield} />
                    Secure Telehealth
                  </div>
                </div>
                <div className="glass-panel flex items-center gap-5 rounded-[2rem] p-6 shadow-xl">
                  <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-600">
                    <SafeIcon icon={FiStar} className="h-6 w-6 fill-emerald-600" />
                  </div>
                  <div>
                    <div className="mb-1 text-xs font-bold uppercase tracking-wider text-slate-400">Personalized Care</div>
                    <div className="text-xl font-extrabold text-slate-900">Built Around You</div>
                  </div>
                </div>
              </div>
              <div className="space-y-4 sm:space-y-6">
                <img src="https://images.unsplash.com/photo-1490645935967-10de6ba17061?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Healthy lifestyle" className="premium-shadow h-64 w-full rounded-[2rem] object-cover sm:h-80" />
                <img src="https://images.unsplash.com/photo-1522844990619-4951c40f7eda?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Wellness and lifestyle" className="premium-shadow h-40 w-full rounded-[2rem] object-cover sm:h-48" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}